import React from "react";
import { useTranslation } from "react-i18next";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Package, BookOpen, Warehouse, History, Truck, ShoppingCart } from "lucide-react";

import WarehousesView from "../components/inventory/WarehousesView";
import BooksView from "../components/inventory/BooksView";
import InventoryMovementsView from "../components/inventory/InventoryMovementsView";
import StockView from "../components/inventory/StockView";
import ProductsView from "../components/inventory/ProductsView";

export default function Inventory() {
  const { t } = useTranslation();
  
  return (
    <div className="min-h-screen gradient-bg p-6">
      <div className="max-w-7xl mx-auto space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-slate-900">{t('inventory.title')}</h1>
          <p className="text-slate-600 font-medium mt-1">
            {t('inventory.subtitle')}
          </p>
        </div>

        <Tabs defaultValue="stock" className="w-full">
          <TabsList className="grid w-full grid-cols-5">
            <TabsTrigger value="stock">
              <Package className="w-4 h-4 mr-2" />
              {t('inventory.tabs.stock')}
            </TabsTrigger>
            <TabsTrigger value="movements">
              <Truck className="w-4 h-4 mr-2" />
              {t('inventory.tabs.movements')}
            </TabsTrigger>
            <TabsTrigger value="products">
              <ShoppingCart className="w-4 h-4 mr-2" />
              {t('inventory.tabs.products')}
            </TabsTrigger>
            <TabsTrigger value="warehouses">
              <Warehouse className="w-4 h-4 mr-2" />
              {t('inventory.tabs.warehouses')}
            </TabsTrigger>
            <TabsTrigger value="books">
              <BookOpen className="w-4 h-4 mr-2" />
              {t('inventory.tabs.books')}
            </TabsTrigger>
          </TabsList>
          <TabsContent value="stock" className="mt-6">
             <StockView />
          </TabsContent>
          <TabsContent value="movements" className="mt-6">
            <InventoryMovementsView />
          </TabsContent>
          <TabsContent value="products" className="mt-6">
            <ProductsView />
          </TabsContent>
          <TabsContent value="warehouses" className="mt-6">
            <WarehousesView />
          </TabsContent>
          <TabsContent value="books" className="mt-6">
            <BooksView />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}